import { render } from "./RectangleSelectComponent.vue?vue&type=template&id=7d6d499a"
import script from "./RectangleSelectComponent.vue?vue&type=script&lang=js"
export * from "./RectangleSelectComponent.vue?vue&type=script&lang=js"

import "./RectangleSelectComponent.vue?vue&type=style&index=0&id=7d6d499a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__